import { Component, OnInit } from '@angular/core';
import { CategoriaTrabajoService, CongresosService, TrabajosService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';
import { ActivatedRoute } from '@angular/router';

// SWAL
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-trabajos-lista-admin',
  templateUrl: './trabajos-lista-admin.component.html',
  styles: []
})
export class TrabajosListaAdminComponent implements OnInit {

  categoriasSelect: any = [];
  navegacionCategorias: any = [];
  loading: boolean = true;
  congreso: Congreso;
  trabajos = [];

  constructor(public _categoriaTrabajoService: CategoriaTrabajoService,
              private activatedRoute: ActivatedRoute,
              public _congresosService: CongresosService,
              public _trabajosService: TrabajosService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        this.loading = false;
        this.homeNavegacion();
      });
    });
  }

  homeNavegacion() {
    this.trabajos = [];
    this.navegacionCategorias = [];
    this.categoriasSelect = [];
    this.loading = true;

      this._categoriaTrabajoService.getAllCategoriasTrabajo().subscribe((resp: any) => {
      console.log(resp);
      for (let categoriaTrabajo of resp.categoriasTrabajo) {
        console.log(categoriaTrabajo);
        if (!categoriaTrabajo.parent) {
          this.categoriasSelect.push(categoriaTrabajo);
        }
      }
      this.loading = false;
      console.log('Categorias Padres', this.categoriasSelect);
    });
  }

  seleccionarCategoria(categoria) {
    console.log(categoria);
    this.trabajos = [];
    this.navegacionCategorias.push(categoria);
    if (categoria.childrens && categoria.childrens.length > 0) {
      this.categoriasSelect = categoria.childrens;
    } else {
      console.log('no tiene mas childrens');
      this._categoriaTrabajoService.getCategoriaContrabajos(categoria._id, this.congreso._id)
      .subscribe(resp => {
        console.log(resp);
        this.trabajos = resp.trabajos;
      });
    }
  }

  navegarCategoria(i: number, categoria: any) {
    this.trabajos = [];
    if (categoria.childrens && categoria.childrens.length > 0) {
      this.categoriasSelect = categoria.childrens;
    }
    this.navegacionCategorias.splice(i + 1, this.navegacionCategorias.length - 1);
  }

  guardarCodigo(trabajo: any) {
    console.log(trabajo);
    this.loading = true;
    this._trabajosService.guardarCodigoTrabajo(trabajo._id, trabajo.codigoTrabajo).subscribe(resp => {
      console.log(resp);
      this.loading = false;
      swal('Codigo guardado', 'El codigo se ha guardado correctamente.', 'success');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trabajos-lista-admin/trabajos-lista-admin.component.ts